// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__cGo-1","active":"Navbar_active__5QgGt"};